export const checkFileSize = (file, size) => file?.size <= size;

export const checkImageRatio = (file) => {
  return new Promise((resolve) => {
    const img = new Image();

    img.onload = function () {
      const width = this.width;
      const height = this.height;
      resolve(width === height);
    };
    img.src = URL.createObjectURL(file);
  });
};

export const checkValidFileType = (file) => {
  if (
    !file.name.toLowerCase().endsWith('jpg') &&
    !file.name.toLowerCase().endsWith('jpeg') &&
    !file.name.toLowerCase().endsWith('png') &&
    !file.name.toLowerCase().endsWith('gif')
  ) {
    return false;
  }
  return /(image\/jpg|image\/jpeg|image\/png|image\/gif)$/i.test(file.type);
};
